import { v4 as uuidv4 } from "uuid";
import { CartItemType } from "../../services/redux/types/CartLoyaltyV2Types";
import { OrderCartV2Line } from "../../services/redux/types/OrderCartV2Types";
import CartItem from "../CartItem";
import {
  AddLineInput,
  addLineInputToCartItemType,
  cartItemToAddLineInput,
  isCartItemPayload,
} from "./cartLineTypes";
import { addLineInputToOrderLine } from "./orderLineMappers";

export function buildCartLine(
  input: AddLineInput | CartItem,
  useLoyaltyService: boolean
): CartItemType {
  const lineInput = isCartItemPayload(input)
    ? cartItemToAddLineInput(input)
    : input;

  if (useLoyaltyService) {
    throw new Error(
      "buildCartLine is legacy-only; use buildLoyaltyOrderLine for V2"
    );
  }

  if (isCartItemPayload(input)) {
    return input.toJson();
  }

  return addLineInputToCartItemType(lineInput);
}

export function buildLoyaltyOrderLine(
  input: AddLineInput | CartItem
): OrderCartV2Line {
  const lineInput = isCartItemPayload(input)
    ? cartItemToAddLineInput(input)
    : input;

  return addLineInputToOrderLine(lineInput, lineInput.lineId ?? uuidv4());
}
